import React, { Component } from "react";
import axios from "axios";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Container, Row, Col } from "shards-react";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import api from "../api";
import { withStyles } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import Input from "@material-ui/core/Input";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import DeleteIcon from "@material-ui/icons/RemoveCircleOutline";
import NumberFormat from "react-number-format";
import ConfirmDialog from "../../common/ConfirmDialog";
import IconButton from "@material-ui/core/IconButton";
import InfoIcon from "@material-ui/icons/Info";
import Tooltip from "@material-ui/core/Tooltip";
import Checkbox from "@material-ui/core/Checkbox";

const useStyles = theme => ({
  option: {
    fontWeight: 600,
    fontSize: "0.75rem"
  },
  menu: {
    fontSize: "0.75rem"
  },
  tableCell: {
    padding: "3px",
    border: "1px solid #dee2e6"
  },
  tableCellComments: {
    padding: "3px",
    width: "170px"
  }
});

class Detail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tasks: {
        work_order_expense_type_id: "",
        loading: false,
        open: false,
        tasks: [
          {
            task: "",
            work_order_task_action_id: "",
            iva_buy_id: "",
            iva_sell_id: ""
          }
        ],
        options: [{ name: "" }]
      },
      tasks_groups: [],
      task_sub_groups: [],
      default_work_order_task_action_id: "",
      dialog: {
        open: false,
        message: "",
        title: "",
        errors: { errors: { "work_order.tasks": [] } }
      },

      delete_dialog: {
        open: false,
        message: "",
        title: "",
        errors: { errors: { "work_order.tasks": [] } }
      }
    };
    this.handleTasksAsyncChange = this.handleTasksAsyncChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleRemoveTask = this.handleRemoveTask.bind(this);
    this.handleDeleteTask = this.handleDeleteTask.bind(this);
  }

  async componentDidMount() {
    await this.getTasksGroups();
    var tasks = this.state.tasks;
    var work_order_tasks = this.props.detail.tasks.tasks;
    var work_order_expense_type_id = this.props.detail.tasks
      .work_order_expense_type_id;
    tasks.tasks = work_order_tasks;
    tasks.work_order_expense_type_id = work_order_expense_type_id;
    this.setState({ tasks });
  }
  componentWillReceiveProps(nextProps) {
    var tasks = this.state.tasks;
    var work_order_tasks = nextProps.detail.tasks.tasks;
    var work_order_expense_type_id =
      nextProps.detail.tasks.work_order_expense_type_id;
    tasks.tasks = work_order_tasks;
    tasks.work_order_expense_type_id = work_order_expense_type_id;
    this.setState({ tasks });
  }

  getTasksGroups = () => {
    var url = api.tasks;
    if (this.props.filterTasks) {
      url = url + "?work_order_type_id=" + this.props.work_order_type_id;
    }
    const token = localStorage.getItem("userToken");
    return axios
      .get(url, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        var tasks_groups = this.state.tasks_groups;
        tasks_groups = res.data;
        this.setState({ tasks_groups: tasks_groups });
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleTasksAsyncChange = (event, values) => {
    var tasks = this.state.tasks;
    var task_sub_groups = this.state.task_sub_groups;
    var tasks_groups = this.state.tasks_groups;
    var id = event.target.id.replace("-option-0", "").split(".");
    var id = tasks.tasks.length - 1;
    var default_task_action_id = this.props.default_work_order_task_action_id;
    var task = {
      task: values,
      work_order_task_action_id: default_task_action_id
    };
    if (values !== null) {
      task.id = "";
      task.task_sub_group = values.task_sub_group;
      task.task_group = values.task_group;
      if (
        tasks.tasks[id]["work_order_task_action_id"] === "" ||
        tasks.tasks[id]["work_order_task_action_id"] === undefined
      ) {
        task.work_order_task_action_id = default_task_action_id
          ? default_task_action_id
          : "";
      } else {
        task.work_order_task_action_id =
          tasks.tasks[id]["work_order_task_action_id"];
      }
      if (task.task_sub_group === undefined) {
        var tasks_groups = this.state.tasks_groups;
        var task_sub_groups = this.state.task_sub_groups;
        var sub_group = task_sub_groups.filter(
          sub_group => sub_group.id === parseInt(values.parent_id)
        );
        var group = tasks_groups.filter(
          group => group.id === parseInt(sub_group[0].parent_id)
        );
        task.task.task_sub_group = sub_group[0].label;
        task.task.task_group = group[0].label;
      }
      task.task.comments = values.comments;
      tasks.tasks[id] = task;
      tasks.tasks.push({
        task: {
          name: "",
          id: "",
          work_order_task_action_id: default_task_action_id
        }
      });
    }
    //    	values = (values !== null) ? tasks.tasks.push(task) : ''
    //    	values = (values !== null) ? task : ''
    //    	tasks.push({task:{name:''}})
    //    	tasks = (values !== null) ? tasks.tasks.push({task:{name:''}}) : tasks
    //    	tasks.tasks = tasks.tasks.push(values)
    this.setState({ tasks: tasks });
  };

  handleTasksAsyncSearch = (event, values) => {
    var task = values;
    const token = localStorage.getItem("userToken");
    var url = api.work_order().tasks_autocomplete(task);
    if (this.props.filterTasks) {
      url = url + "?work_order_type_id=" + this.props.work_order_type_id;
    }

    if (task.length > 2) {
      return axios
        .get(url, { headers: { Authorization: `Bearer ${token}` } })
        .then(res => {
          var tasks = this.state.tasks;
          tasks.options = res.data;
          this.setState({ tasks: tasks });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  handleConfirmDeleteTask = (e, id, idx) => {
    var delete_dialog = this.state.delete_dialog;
    delete_dialog.open = true;
    delete_dialog.title = "Orden de trabajo";
    delete_dialog.message =
      "Esta seguro de eliminar la tarea? La misma se eliminará de la orden de trabajo y presupuestos sin aprobar.";
    this.setState({ delete_dialog: delete_dialog, delete_task_id: id });

    return;
  };

  handleDeleteTask(e) {
    var id = this.state.delete_task_id;
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .delete(
        api.work_order_tasks().delete(id),
        { headers: { Authorization: `Bearer ${token}` } },
        { params: { id: id } }
      )
      .then(response => {
        var array_id = "";
        self.state.tasks.tasks.map((val, idx) => {
          if (val.id === id) {
            array_id = idx;
          }
        });
        var tasks = self.state.tasks;
        //		    	tasks.tasks = tasks.tasks.filter((s, sidx) => array_id !== sidx)
        tasks.tasks.splice(array_id, 1);
        const default_task_action_id = this.props
          .default_work_order_task_action_id;
        if (tasks.tasks.length <= 1) {
          tasks.tasks.push({
            task: {
              name: "",
              id: "",
              work_order_task_action_id: default_task_action_id
            }
          });
        }

        self.setState({ tasks });
      })
      .catch(function(error) {});
  }

  handleRemoveTask(e, id) {
    e.preventDefault();
    var tasks = this.state.tasks;
    //    	tasks.tasks = tasks.tasks.filter((s, sidx) => id !== sidx)
    tasks.tasks.splice(id, 1);
    if (tasks.tasks.length === 1) {
      if (tasks.tasks[0].task.id !== "") {
        const default_task_action_id = this.props
          .default_work_order_task_action_id;
        tasks.tasks.push({
          task: {
            name: "",
            id: "",
            work_order_task_action_id: default_task_action_id
          }
        });
      }
    } else if (tasks.tasks.length < 1) {
      const default_task_action_id = this.props
        .default_work_order_task_action_id;
      tasks.tasks.push({
        task: {
          name: "",
          id: "",
          work_order_task_action_id: default_task_action_id
        }
      });
    }
    this.setState({ tasks });
  }

  handleChange(e) {
    if (e.target.name === "work_order_expense_type_id") {
      var tasks = this.state.tasks;
      tasks.work_order_expense_type_id = e.target.value;
      this.setState({ tasks });
    } else {
      var element = e.target.name.split(".");
      var key = element[0];
      var id = element[1];
      var tasks = this.state.tasks;
      if (key === "task_group" || key === "task_sub_group") {
        var task_sub_groups = this.state.task_sub_groups;
        var tasks_groups = this.state.tasks_groups;
        if (key === "task_group") {
          var group = tasks_groups.filter(
            group => group.id === parseInt(e.target.value)
          );
          task_sub_groups = group[0] ? group[0].children : [];
          this.setState({ task_sub_groups: task_sub_groups });
        } else {
          var sub_group = task_sub_groups.filter(
            sub_group => sub_group.id === parseInt(e.target.value)
          );
          var options = sub_group[0] ? sub_group[0].children : [];
          tasks.options = options;
        }
      } else {
        if (
          key === "rebill" ||
          key === "materials_s_iva_price" ||
          key === "workforce_s_iva_price" ||
          key === "total_s_iva_price" ||
          key === "total_discount"
        ) {
          e.target.value = e.target.value.replace("$", "");
        }
      }
      if (key === "bonificado") {
        var checked = e.target.checked;
        tasks.tasks[id][key] = checked;
        var totalLine = +tasks.tasks[id]["total_s_iva_price"] || 0;
        tasks.tasks[id]["total_discount"] = checked
          ? totalLine
          : 0;
      } else {
        tasks.tasks[id][key] = e.target.value;
      }
      if (
        tasks.tasks[id]["materials_s_iva_price"] > 0 ||
        tasks.tasks[id]["workforce_s_iva_price"] > 0
      ) {
        tasks.tasks[id]["total_s_iva_price"] =
          +tasks.tasks[id]["materials_s_iva_price"] +
          +tasks.tasks[id]["workforce_s_iva_price"];
      }
      this.setState({ tasks });
    }
  }

  handleDialogClose = () => {
    var delete_dialog = this.state.delete_dialog;
    delete_dialog.open = false;
    delete_dialog.errors = [];

    this.setState({ delete_dialog: delete_dialog, delete_task_id: "" });
  };

  render() {
    const tasks = this.state.tasks;
    const work_order_expense_types = this.props.work_order_expense_types;
    const classes = this.props.classes;
    const task_action_types = this.props.task_action_types;
    const work_order_aditional_column =
      this.props.work_order_expense_type_id !== 1 &&
      this.state.tasks.work_order_expense_type_id !== 1 &&
      this.props.work_order_expense_type_id !== 5 &&
      this.state.tasks.work_order_expense_type_id !== 5
        ? "none"
        : "";
    const iva_conditions = this.props.iva_conditions;
    const is_approved = this.props.is_approved;
    const totals = this.props.totals
      ? this.props.totals
      : {
          total_s_iva_price: 0,
          materials_s_iva_price: 0,
          workforce_s_iva_price: 0
        };
    if (this.props.show_budget_required_label) {
      return (
        <React.Fragment>Debe cargar primero el presupuesto.</React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <ConfirmDialog
          confirm_dialog={this.state.delete_dialog.open}
          title={this.state.delete_dialog.title}
          message={this.state.delete_dialog.message}
          onClose={this.handleDialogClose}
          onAccept={e => {
            this.handleDeleteTask(e);
          }}
          onCancel={this.handleDialogClose}
          errors={this.state.delete_dialog.errors}
        />

        <Row>
          <Col className="px-0">
            <Typography variant="caption">
              <Table
                size="small"
                aria-label="a dense table"
                style={{ width: "auto", minWidth: "650px", marginTop: "8px" }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550", fontSize: "0.8rem" }}
                    >
                      Accion
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550", fontSize: "0.8rem" }}
                    >
                      Grupo
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550", fontSize: "0.8rem" }}
                    >
                      Subgrupo
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550", fontSize: "0.8rem" }}
                    >
                      Tarea
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550", fontSize: "0.8rem" }}
                    >
                      MO S/IVA
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550", fontSize: "0.8rem" }}
                    >
                      Repuestos S/IVA
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{
                        fontWeight: "550",
                        fontSize: "0.8rem",
                        display: work_order_aditional_column
                      }}
                    >
                      Adicional
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550", fontSize: "0.8rem" }}
                    >
                      Total S/IVA
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550", fontSize: "0.8rem" }}
                    >
                      Descuentos
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550", fontSize: "0.8rem" }}
                    >
                      IVA C
                    </TableCell>
                    {/*<TableCell className={classes.tableCell} style={{fontWeight: '550', fontSize: '0.8rem'}} >IVA V</TableCell>*/}
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550", fontSize: "0.8rem" }}
                    >
                      Bonificado
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550", fontSize: "0.8rem" }}
                    >
                      Comentarios
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550", fontSize: "0.8rem" }}
                    >
                      &nbsp;
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tasks.tasks.map((val, idx) => {
                    if (val.authorization_matrix_approval_role) {
                      var authorization_matrix_text = val.authorization_matrix_approval_role.join(
                        ","
                      );
                      //var authorization_matrix_text = (val.authorization_matrix_approval_role) ? val.authorization_matrix_approval_role : ''
                    }
                    var policy_text = val.policy_action
                      ? val.policy_action
                      : "";
                    var task_info_display =
                      (!is_approved &&
                        (authorization_matrix_text || policy_text)) ||
                      val.task.commnets
                        ? ""
                        : "none";
                    if (val.task.comments) {
                      task_info_display = "";
                    }
                    const canEditValues = val.can_edit_values;
                    return (
                      <TableRow>
                        <TableCell className={classes.tableCell}>
                          <FormControl
                            style={{ fontSize: "0.75rem" }}
                            name={"work_order_task_action_id." + idx}
                          >
                            <Select
                              native
                              name={"work_order_task_action_id." + idx}
                              inputProps={{
                                name: "work_order_task_action_id." + idx,
                                className: "work_order_task_action_id." + idx
                              }}
                              value={val.work_order_task_action_id}
                              style={{ fontSize: "0.75rem" }}
                              onChange={this.handleChange}
                              required
                              input={
                                <Input
                                  id="grouped-native-select"
                                  name="contract_id"
                                />
                              }
                            >
                              <option value="" />
                              {task_action_types.map(action => (
                                <option id={action.name} value={action.id}>
                                  {action.name}
                                </option>
                              ))}
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.7rem" }}
                        >
                          {val.task.task_group ? (
                            <div>{val.task.task_group}</div>
                          ) : (
                            <FormControl
                              style={{ fontSize: "0.75rem" }}
                              name={"task_group." + idx}
                            >
                              <Select
                                native
                                name={"task_group." + idx}
                                inputProps={{
                                  name: "task_group." + idx,
                                  className: "task_group." + idx
                                }}
                                value={val.task_group ? val.task_group : ""}
                                style={{ fontSize: "0.75rem" }}
                                onChange={this.handleChange}
                                required
                                input={
                                  <Input
                                    id="grouped-native-select"
                                    name="contract_id"
                                  />
                                }
                              >
                                <option value="" />
                                {this.state.tasks_groups.map(task_group => (
                                  <option
                                    id={task_group.name}
                                    value={task_group.id}
                                  >
                                    {task_group.name}
                                  </option>
                                ))}
                              </Select>
                            </FormControl>
                          )}
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.7rem" }}
                        >
                          {val.task.task_sub_group ? (
                            <div>{val.task.task_sub_group}</div>
                          ) : (
                            <FormControl
                              style={{ fontSize: "0.75rem" }}
                              name={"task_sub_group." + idx}
                            >
                              <Select
                                native
                                name={"task_sub_group." + idx}
                                inputProps={{
                                  name: "task_sub_group." + idx,
                                  className: "task_sub_group." + idx
                                }}
                                value={
                                  val.task_sub_group ? val.task_sub_group : ""
                                }
                                style={{ fontSize: "0.75rem" }}
                                onChange={this.handleChange}
                                required
                                input={
                                  <Input
                                    id="grouped-native-select"
                                    name="contract_id"
                                  />
                                }
                              >
                                <option value="" />
                                {this.state.task_sub_groups.map(
                                  task_sub_group => (
                                    <option
                                      id={task_sub_group.name}
                                      value={task_sub_group.id}
                                    >
                                      {task_sub_group.name}
                                    </option>
                                  )
                                )}
                              </Select>
                            </FormControl>
                          )}
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.7rem" }}
                        >
                          {val.task.name ? (
                            <div>
                              {val.task.name}{" "}
                              <Tooltip
                                title={
                                  <React.Fragment>
                                    <Typography style={{ fontSize: "0.75rem" }}>
                                      {authorization_matrix_text ? (
                                        <div>
                                          Aprobación:{" "}
                                          <span
                                            style={{
                                              fontSize: "0.8rem",
                                              fontWeight: 600
                                            }}
                                          >
                                            {authorization_matrix_text}
                                          </span>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                      {policy_text ? (
                                        <div>
                                          Acción por política:{" "}
                                          <span
                                            style={{
                                              fontSize: "0.8rem",
                                              fontWeight: 600
                                            }}
                                          >
                                            {policy_text}
                                          </span>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                      {val.task.comments ? (
                                        <div>
                                          Comentarios:{" "}
                                          <span
                                            style={{
                                              fontSize: "0.8rem",
                                              fontWeight: 600
                                            }}
                                          >
                                            {val.task.comments}
                                          </span>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </Typography>
                                  </React.Fragment>
                                }
                              >
                                <InfoIcon
                                  style={{
                                    display: task_info_display,
                                    width: 15
                                  }}
                                />
                              </Tooltip>
                            </div>
                          ) : (
                            <React.Fragment>
                              <Autocomplete
                                id={"tasks." + idx}
                                name={"tasks." + idx}
                                style={{ width: 230 }}
                                getOptionLabel={option => option.name}
                                getOptionSelected={(option, value) =>
                                  option.name === value
                                }
                                options={this.state.tasks.options}
                                loading={this.state.tasks.loading}
                                onInputChange={this.handleTasksAsyncSearch}
                                onChange={this.handleTasksAsyncChange.bind(
                                  this
                                )}
                                autoComplete
                                noOptionsText={
                                  <Typography variant="caption">
                                    Sin resultados
                                  </Typography>
                                }
                                includeInputInList
                                className="mt-2 mr-2"
                                classes={{
                                  option: classes.option
                                }}
                                renderInput={params => (
                                  <TextField
                                    {...params}
                                    placeholder="Ingrese una tarea"
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <React.Fragment>
                                          {this.state.tasks.loading ? (
                                            <CircularProgress
                                              color="inherit"
                                              size={20}
                                            />
                                          ) : null}
                                          {params.InputProps.endAdornment}
                                        </React.Fragment>
                                      )
                                    }}
                                    InputLabelProps={{
                                      ...params.InputLabelProps,
                                      shrink: true
                                    }}
                                    inputProps={{
                                      ...params.inputProps,
                                      style: { fontSize: "0.75rem", width: 230 }
                                    }}
                                  />
                                )}
                              />
                            </React.Fragment>
                          )}
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.7rem" }}
                        >
                          <NumberFormat
                            id={"workforce_s_iva_price." + idx}
                            name={"workforce_s_iva_price." + idx}
                            disabled={
                              !this.props.work_force_price_enable ||
                              !val.task.workforce_account_cost ||
                              !canEditValues
                            }
                            placeholder="Ingrese mano de obra"
                            value={val.workforce_s_iva_price}
                            onChange={this.handleChange}
                            className="m-0 p-0"
                            InputProps={{
                              style: { minWidth: 70, fontSize: "0.75rem" }
                            }}
                            decimalSeparator="."
                            prefix={"$"}
                            customInput={TextField}
                            InputLabelProps={{
                              shrink: true
                            }}
                            isAllowed={values => {
                              let { floatValue } = values;
                              floatValue =
                                floatValue !== undefined ? floatValue : 0;
                              return floatValue >= 0 && floatValue < 99999999;
                            }}
                          />
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.7rem" }}
                        >
                          <NumberFormat
                            id={"materials_s_iva_price." + idx}
                            name={"materials_s_iva_price." + idx}
                            placeholder="Ingrese materiales"
                            value={val.materials_s_iva_price}
                            disabled={
                              !this.props.materials_price_enable ||
                              !val.task.materials_account_cost ||
                              !canEditValues
                            }
                            onChange={this.handleChange}
                            className="m-0 p-0"
                            InputProps={{
                              style: { minWidth: 70, fontSize: "0.75rem" }
                            }}
                            decimalSeparator="."
                            prefix={"$"}
                            customInput={TextField}
                            InputLabelProps={{
                              shrink: true
                            }}
                            isAllowed={values => {
                              let { floatValue } = values;
                              floatValue =
                                floatValue !== undefined ? floatValue : 0;
                              return floatValue >= 0 && floatValue < 99999999;
                            }}
                          />
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{
                            display: work_order_aditional_column,
                            fontSize: "0.7rem"
                          }}
                        >
                          <NumberFormat
                            disabled={canEditValues ? false : true}
                            id={"rebill." + idx}
                            name={"rebill." + idx}
                            placeholder="Ingrese el adicional"
                            value={val.rebill}
                            onChange={this.handleChange}
                            className="m-0 p-0"
                            InputProps={{
                              style: { minWidth: 70, fontSize: "0.75rem" }
                            }}
                            decimalSeparator="."
                            prefix={"$"}
                            customInput={TextField}
                            InputLabelProps={{
                              shrink: true
                            }}
                            isAllowed={values => {
                              let { floatValue } = values;
                              floatValue =
                                floatValue !== undefined ? floatValue : 0;
                              return floatValue >= 0 && floatValue < 99999999;
                            }}
                          />
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <NumberFormat
                            id={"total_s_iva_price." + idx}
                            name={"total_s_iva_price." + idx}
                            value={val.total_s_iva_price}
                            disabled={
                              !this.props.total_price_enable || !canEditValues
                            }
                            placeholder="Ingrese el total"
                            //value={val.workforce_s_iva_price}
                            onChange={this.handleChange}
                            className="m-0 p-0"
                            InputProps={{
                              style: { minWidth: 70, fontSize: "0.75rem" }
                            }}
                            decimalSeparator="."
                            prefix={"$"}
                            customInput={TextField}
                            InputLabelProps={{
                              shrink: true
                            }}
                            isAllowed={values => {
                              let { floatValue } = values;
                              floatValue =
                                floatValue !== undefined ? floatValue : 0;
                              return floatValue >= 0 && floatValue < 99999999;
                            }}
                          />
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.7rem" }}
                        >
                          <NumberFormat
                            id={"total_discount." + idx}
                            name={"total_discount." + idx}
                            placeholder="Ingrese el descuento"
                            value={val.total_discount}
                            disabled
                            onChange={this.handleChange}
                            className="m-0 p-0"
                            InputProps={{
                              style: { minWidth: 70, fontSize: "0.75rem" }
                            }}
                            decimalSeparator="."
                            prefix={"$"}
                            customInput={TextField}
                            InputLabelProps={{
                              shrink: true
                            }}
                            isAllowed={values => {
                              let { floatValue } = values;
                              floatValue =
                                floatValue !== undefined ? floatValue : 0;
                              return floatValue >= 0 && floatValue < 99999999;
                            }}
                          />
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <FormControl
                            style={{ fontSize: "0.75rem" }}
                            name={"iva_buy_id." + idx}
                          >
                            <Select
                              native
                              name={"iva_buy_id." + idx}
                              inputProps={{
                                name: "iva_buy_id." + idx,
                                className: "iva_buy_id." + idx
                              }}
                              value={val.iva_buy_id}
                              style={{ fontSize: "0.75rem" }}
                              onChange={this.handleChange}
                              required
                              input={
                                <Input
                                  id="grouped-native-select"
                                  name="contract_id"
                                />
                              }
                            >
                              <option value="" />
                              {iva_conditions.buy.map(condition => (
                                <option
                                  id={condition.name}
                                  value={condition.id}
                                >
                                  {condition.name}
                                </option>
                              ))}
                            </Select>
                          </FormControl>
                        </TableCell>
                        {/*
							            <TableCell className={classes.tableCell}>
									      <FormControl style={{fontSize: '0.75rem'}} name={"iva_sell_id."+idx} >
									        <Select native name={"iva_sell_id."+idx}
									            inputProps={{
									              name:"iva_sell_id."+idx,
									              className:"iva_sell_id."+idx
									            }}
									            value={val.iva_sell_id}
									            style={{fontSize: '0.75rem'}}
									            onChange={this.handleChange}
									            required
									            input={<Input id="grouped-native-select" name='contract_id'/>}>
									            <option value="" />
									            {iva_conditions.sell.map((condition) => <option id={condition.name} value={condition.id}>{condition.name}
									          </option>)}
									        </Select>
									      </FormControl>
							            </TableCell>
										*/}
                        <TableCell className={classes.tableCell}>
                          <Checkbox
                            id={"bonificado." + idx}
                            name={"bonificado." + idx}
                            color="primary"
                            checked={val.bonificado === true || (+val.total_discount === +val.total_s_iva_price && +val.total_discount !== 0 && +val.total_s_iva_price !== 0)}
                            onChange={this.handleChange}
                            size="small"
                          />
                        </TableCell>

                        <TableCell className={classes.tableCellComments}>
                          <TextField
                            id={"comments." + idx}
                            name={"comments." + idx}
                            onChange={this.handleChange}
                            type="text"
                            value={val.comments}
                            margin="normal"
                            className="mr-2 mt-1"
                            InputProps={{
                              style: { minWidth: 130, fontSize: "0.75rem" }
                            }}
                            InputLabelProps={{
                              shrink: true
                            }}
                          />
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <IconButton
                            size="small"
                            onClick={e => {
                              val.id
                                ? this.handleConfirmDeleteTask(e, val.id, idx)
                                : this.handleRemoveTask(e, idx);
                            }}
                            disabled={
                              !(
                                val.id === undefined ||
                                val.id === "" ||
                                this.props.can_delete
                              )
                            }
                          >
                            <DeleteIcon
                              onClick={e => {
                                val.id
                                  ? this.handleConfirmDeleteTask(e, val.id, idx)
                                  : this.handleRemoveTask(e, idx);
                              }}
                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {totals.total_s_iva_price !== 0 ? (
                    <React.Fragment>
                      <TableRow>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          Total
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          &nbsp;
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          &nbsp;
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          &nbsp;
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          ${totals.workforce_s_iva_price}
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          ${totals.materials_s_iva_price}
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{
                            fontWeight: "550",
                            display: work_order_aditional_column
                          }}
                        >
                          &nbsp;
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          ${totals.total_s_iva_price}
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          &nbsp;
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          &nbsp;
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          &nbsp;
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: "550" }}
                        >
                          &nbsp;
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ) : (
                    ""
                  )}
                </TableBody>
              </Table>
            </Typography>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default withStyles(useStyles)(Detail);
